// extracted by css-extract-rspack-plugin
export default {"link":"_b51eb470","item":"_4ac67845","fullWidth":"_ce3209e5","image":"_10689697","isFullBleed":"_5d961f3","imageCopy":"_ad9a68d2","tileImage":"_e9d09e63","header":"_e5d06c8f"};